"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageShowsModuleLayouts = void 0;
exports.SetPageShowsModuleLayouts = ["list", "swiper"];
//# sourceMappingURL=Shows.js.map